import { UpdateLeadPayload } from '@/services/api/MarketingApiTypes';
import { TrackingHelper } from '@/utils/tracking';
import { FormSortAnswersService } from './FormSortAnswersService';
import { buildLeadPayload } from './LeadPayloadBuilder';

export class UpdateLeadService {
  private answersService: FormSortAnswersService;
  private leadId: string;
  private promotion?: string;

  constructor({
    answersService,
    leadId,
    promotion,
  }: {
    answersService: FormSortAnswersService;
    leadId: string;
    promotion?: string;
  }) {
    this.answersService = answersService;
    this.leadId = leadId;
    this.promotion = promotion;
  }

  private async postUpdateLead(payload: UpdateLeadPayload): Promise<void> {
    const response = await fetch('/api/update-lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => '');

      console.error('API request failed:', {
        status: response.status,
        message: errorText,
      });

      throw new Error('Something went wrong. Please try again later.');
    }
  }

  async updateLead(): Promise<void> {
    const trackingData = TrackingHelper.getTrackingData();

    const payload = buildLeadPayload({
      answersService: this.answersService,
      leadId: this.leadId,
      trackingData,
      promotion: this.promotion,
    });

    await this.postUpdateLead(payload);
  }
}
